import { either } from "fp-ts";
import React, { FunctionComponent, useContext, useEffect, useMemo, useState } from "react";
import { Action, DomainError, initializeAangifte, Aangifte, Seed } from "domain/aangifte";

export interface Props {
  initialAangifte: Seed;
  onChange?(aangifte: Aangifte): void;
}

interface AangifteContext {
  aangifte: Aangifte;
  dispatch(action: Action): either.Either<DomainError, Aangifte>;
}

const Context = React.createContext<AangifteContext>({
  aangifte: undefined as any,
  dispatch: () => {
    throw new Error("Failed to initialize the context");
  },
});

export const AangifteProvider: FunctionComponent<Props> = ({ children, onChange, initialAangifte: seed }) => {
  const [initialAangifte, dispatch] = useMemo(
    () =>
      initializeAangifte((a) => {
        setAangifte(a);
      }, seed),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  const [aangifte, setAangifte] = useState(initialAangifte);

  useEffect(() => {
    onChange && onChange(aangifte);
  }, [aangifte, onChange]);

  return <Context.Provider value={{ dispatch, aangifte }}>{children}</Context.Provider>;
};

AangifteProvider.displayName = "AangifteProvider";

export const useAangifte = () => useContext(Context);
